import { api } from './client';

export const changePassword = (email, oldPassword, newPassword, confirmPassword) => {
  return api({
    method: 'POST',
    url: '/users/changepassword',
    data: { Email: email, OldPassword: oldPassword, NewPassword: newPassword, ConfirmPassword: confirmPassword },
    meta: { authless: false },
  });
};

export const resetPassword = (email, hashCode, newPassword, confirmPassword) => {
  return api({
    method: 'POST',
    url: '/users/resetpassword',
    data: { Email: email, Password: newPassword, ConfirmPassword: confirmPassword, Code: hashCode },
    meta: { authless: true },
  });
};

export const getSecurityQuestions = (login) => {
  return api.get(`/users/usersequrityquestions?userName=${encodeURIComponent(login)}`, { meta: { authless: true } });
};

export const submitAnswer = (email, questionId, answer) => {
  const clientUrl = `https://${window.location.host}/resetpassword`;
  return api({
    method: 'POST',
    url: '/users/forgotpassword',
    data: { Email: email, UserQuestionId: questionId, UserAnswer: answer, ClientUrl: clientUrl },
    meta: { authless: true },
  });
};
